var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "generic_payload_view"
  }, [!_vm.isError ? [_c('div', {
    staticClass: "generic_view"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  }), _vm.title ? _c('p', {
    staticClass: "nft_title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.desc ? _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e()])] : [_c('p', [_vm._v("Failed to load generic NFT payload.")])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }